import { render, staticRenderFns } from "./imagesZoom.vue?vue&type=template&id=683aa0c8&scoped=true&"
import script from "./imagesZoom.vue?vue&type=script&lang=js&"
export * from "./imagesZoom.vue?vue&type=script&lang=js&"
import style0 from "./imagesZoom.vue?vue&type=style&index=0&id=683aa0c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683aa0c8",
  null
  
)

export default component.exports